function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'deep-teal-heather': 'rgb(80, 112, 125)','canvas-red-heather': 'rgb(141, 27, 27)','neon-yellow': 'rgb(212, 223, 85)','solid-black-blend': 'rgb(3, 3, 3)','team-purple-heather': 'rgb(92, 61, 99)','team-purple': 'rgb(57, 29, 90)','columbia-blue': 'rgb(99, 141, 201)','teal': 'rgb(164, 220, 215)','light-purple': 'rgb(211, 143, 184)','cardinal': 'rgb(111, 37, 32)',};

    this.images = {'black-sleeves-white-body': 'url("//drawingsbytrent.com/cdn/shop/files/White_-_Black_120x.jpg?v=6815418981830119190")','navy-sleeves-grey-body': 'url("//drawingsbytrent.com/cdn/shop/files/Grey_-_Navy_120x.jpg?v=6981144295739542721")','spider-royal-blue': 'url("//drawingsbytrent.com/cdn/shop/files/Spider_Blue_Tie_Dye_120x.png?v=12976340187973708065")','moss': 'url("//drawingsbytrent.com/cdn/shop/files/Moss_swatch_120x.png?v=8905615291499187805")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
